module.exports = __webpack_public_path__ + "img/Mask Group@2x.ee8a36ef.png";